function toUpperCase(value) {
  return value.toUpperCase();
}

export default toUpperCase;